module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("k9F6T"))).then(() => parcelRequire('2KbAe'));